import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import Swal from 'sweetalert2';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { NavigationEnd, Params, Router } from '@angular/router';
import { ProductService } from '../product.service';
import {Location} from '@angular/common'; 
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-products-import',
  templateUrl: './products-import.component.html',
  styleUrls: ['./products-import.component.scss']
})
export class ProductsImportComponent extends FeaturesBaseComponent implements OnInit, OnDestroy{
  fileToUpload: File = null;
  importPricelistForm: FormGroup;
  Pricelists: Array<any>;
  previousUrl: string;
  providers: any;
  fileuploaded: boolean = false;

  constructor(private _location: Location, 
    private fb: FormBuilder, 
    private router: Router, 
    public dialog: MatDialog, 
    private productService: ProductService, 
    private toastr:ToastrService) {
    super();
   }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.fileuploaded = true;
  }
  uploadFileToActivity() {
    let providerid = 1;
    this.productService.postFile(this.fileToUpload,providerid).subscribe(data => {
      // do something, if upload success
      }, error => {
       
      });
  }




  private initForm() {
    this.importPricelistForm = this.fb.group({
      file : [''],
      providerid : ['', [Validators.required]]
    })
  }

  get f() {
    return this.importPricelistForm.controls;
  }
  charMask(rawValue: string): RegExp[] {
    const mask = /^[A-Z|a-z|0-9| ]+$/;
    const strLength = String(rawValue).length;
    const nameMask: RegExp[] = [];

    for (let i = 0; i <= strLength; i++) {
      nameMask.push(mask);
    }

    return nameMask;

  }

  ngOnInit(): void {
    super.ngOnInit();
      // Provider Service
      this.productService.getactiveproviders().subscribe(
        res => {
          let _providerService: any = res;
          if (_providerService.httpcode == 200) {
            this.providers = _providerService.data;
           
  
          }
        }
      );
    this.importPricelistForm = this.fb.group({
      file : [''],
      providerid : ['', [Validators.required]]

    })
  }
  onCancel() { this.router.navigate(['features/products/all-products']);}
  onSubmit() {
   
    if (this.importPricelistForm.valid) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          message: 'pages.placeholders.Areyousureyouwanttosavethechanges',
          buttonText: {
            ok: 'pages.placeholders.Save',
            cancel: 'pages.placeholders.cancel'
          }
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          let providerid = this.importPricelistForm.get('providerid').value;
         
          
          this.productService.postFile(this.fileToUpload, providerid).subscribe(res => {  
           
           
              if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
                //alert("Hello123")
                let _message = 'Total Excel Records :' + res.data.numberOfExcelRecords + ' Rows Inserted :' + res.data.numberOfRowsInserted + ' Rows Updated :' + res.data.numberOfRowsUpdated + '  Import completed successfully'
                this.toastrService.success(_message, 'Success', {
                  timeOut: 3000,
                });
                this.router.navigate(['features/products/all-products'])   
                return;                     
            }else {
              Swal.fire(
                {
                  title: res.responseStatus,
                  text: res.userMessage,
                  icon: 'error',
                  timer: 2000
                }
              )
              this.router.navigate(['features/products/all-products'])
            }
          
          });

        }else{
          //alert("Hello");
          this.router.navigate(['features/products/all-products']);
        }
      });

    }
    //
  }  
}
